import React from "react";

const UpdateSection = () => {
  return (
    <>
      <div className="row justify-content-center pb-2">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <h2 className="text-white">Updates</h2>
        </div>
      </div>
      <div className="row justify-content-center p-4 pt-4 pb-2">
        <div className="col-12 pt-3">
          <div className="update-columns update-columns-new">
            <p>
              Outpatient ( OP )
              <br />
              <b> 9 am to 8 pm Mon-Sat </b>
              <br />
              <b>10 am to 1 pm Sun; Call: for appointments</b>
            </p>
            <p className="mb-2">
              <a
                href="tel:08548249008"
                rel="noreferrer"
                className="btn btn-primary consultaion-call"
              >
                <i className="fa fa-phone consultaion-phoneIcon" /> CALL 085482
                49008
              </a>
            </p>
            <p className="mb-2">
              <a
                href="tel:09133355446 "
                rel="noreferrer"
                className="btn btn-primary consultaion-call"
              >
                <i className="fa fa-phone consultaion-phoneIcon" /> CALL 091333
                55446
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateSection;
